<!----------------------------------------------------------------------------------
about：文本超出s... tooltip show more
author：ss
date：2021-08-06
----------------------------------------------------------------------------------->

<template>
  <section ref="textTooltipWrap" class="erp-tml-common-text-tooltip-wrap">
    <a-tooltip
      v-if="text"
      :overlayClassName="overlayClassName"
      :visible="isShowTooltip"
      :placement="placement"
    >
      <template slot="title">
        <span>{{ text }}</span>
      </template>
      <a
        v-if="isLink"
        :class="textClassName"
        :style="textStyle"
        :href="linkUrl"
        target="_blank"
        @mouseover="hanldeElTooltip"
        @mouseleave="closeElTooltip"
      >{{ text }}</a>
      <p
        v-else
        :class="textClassName"
        :style="textStyle"
        @mouseover="hanldeElTooltip"
        @mouseleave="closeElTooltip"
      >{{ text }}</p>
      <slot name="suffix"></slot>
    </a-tooltip>
    <p v-else>{{ noData }}</p>
  </section>
</template>

<script>
export default {
  name: 'TextTooltip',
  props: {
    placement: {
      // Tooltip 出现位置
      type: String,
      default: 'top'
    },
    text: {
      // 文案
      type: [String, Number],
      default: ''
    },
    lines: {
      // 行数，几行显示省略号
      type: String,
      default: '1'
    },
    isLink: {
      type: Boolean,
      default: false
    },
    linkUrl: {
      type: String,
      default: ''
    },
    overlayClassName: {
      type: String,
      default: 'my-light-tooltip'
    },
    noData: {
      type: String,
      default: '--'
    },
    textStyle: {
      type: [Object, String],
      default: ''
    }
  },
  data () {
    return {
      isShowTooltip: false,
      timer: null
    }
  },
  computed: {
    textClassName () {
      const linesMap = {
        1: 'text-overflow_ellipsis',
        2: 'text-overflow_ellipsis_line_2'
      }
      return linesMap[this.lines]
    }
  },
  methods: {
    /* ----------------------------------------- 绑定方法 ----------------------------------------- */
    hanldeElTooltip (val) {
      this.timer = setTimeout(() => {
        this.isShowTooltip = val.target.scrollWidth > val.target.clientWidth
      }, 300)
    },
    closeElTooltip () {
      clearTimeout(this.timer)
      this.isShowTooltip = false
    }
    /* ----------------------------------------- 自定义方法 ----------------------------------------- */
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.erp-tml-common-text-tooltip-wrap {
  width: auto;
}
</style>
